import { render, staticRenderFns } from "./FormConfigList.vue?vue&type=template&id=883309c2&"
import script from "./FormConfigList.vue?vue&type=script&lang=js&"
export * from "./FormConfigList.vue?vue&type=script&lang=js&"
import style0 from "./FormConfigList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports